import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendAPI } from '@core/models/backend-api';
import { PlacementCategory } from '@core/models/placement-category.model';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class PlacementCategoryService {

	constructor(private http: HttpClient) { }

	getPlacementCategories(): Observable<PlacementCategory[]> {
		const url = BackendAPI.staticDataPlacementCategories;
		return this.http.get<PlacementCategory[]>(url);
	}
}
